<template>
  <div v-if="globalCompanyPermission && globalUserPermission">
    <ejs-dropdownbutton
      :id="`btnActions${data.id}`"
      :items="adminItems"
      css-class="e-caret-hide grid-action p-0"
      :select="onSelect"
      :open="onOpen"
    >
      <font-awesome-icon
        :icon="['fas', 'ellipsis-v']"
        size="sm"
      />
    </ejs-dropdownbutton>
  </div>
  <div v-else>
    <ejs-dropdownbutton
      :id="`btnActions${data.id}`"
      :items="userItems"
      css-class="e-caret-hide grid-action p-0"
      :select="onSelect"
      :open="onOpen"
    >
      <font-awesome-icon
        :icon="['fas', 'ellipsis-v']"
        size="sm"
      />
    </ejs-dropdownbutton>
  </div>
</template>

<script>
import { iframeParentCommunication } from '../../mixins/iframeParentCommunication'
import { mapGetters } from 'vuex'

export default {
  mixins: [iframeParentCommunication],
  inject: ['actions'],
  data () {
    return {
      data: {},
      userItems: [{ text: 'Use this Template', id: 'prebuiltClone' }],
      adminItems: [{ text: 'Details', id: 'details' },
        { text: 'Edit', id: 'edit' },
        { text: 'Clone', id: 'clone' }],
      ...this.actions()
    }
  },
  computed: {
    ...mapGetters({
      accountId: 'getAccountId',
      globalCompanyPermission: 'getGlobalCompanyPermission',
      globalUserPermission: 'getGlobalUserPermission'
    })
  },
  methods: {
    onSelect (args) {
      try {
        const templateId = this.data.id
        if (templateId) {
          if (args.item.text === 'Details') {
            this.details(templateId)
          } else if (args.item.text === 'Edit') {
            this.edit(templateId, this.data.editorTypeId)
          } else if (args.item.text === 'Clone') {
            this.clone(templateId, this.data.editorTypeId)
          } else if (args.item.text === 'Use this Template') {
            this.prebuiltClone(templateId, this.data.editorTypeId)
          } else {
            console.log('None')
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    onOpen (args) {
      args.element.parentElement.style.marginLeft = '-20px'
      this.$store.commit('SET_GRIDSELECTEDTEMPLATE', this.data)
    }
  }
  /* moutend() {
    if (globalCompanyCheckbox && globalUserCheckbo) {
      this.items.push(
        { text: 'Details', id: 'details' },
        { text: 'Clone', id: 'clone' },
        );
      }
    }
    */
}
</script>

<style lang="scss" scoped>

</style>
